// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav {
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
  max-width: 74rem;
  margin-left: 0px;
  margin-right: 0px;
  font-size: 16px;
}
@media screen and (min-width: 991px) {
  .nav {
    margin-right: auto;
    margin-left: auto;
    padding-right: 2rem;
    padding-left: 2rem;
  }
}
.nav a {
  text-decoration: none;
}
.nav .logo {
  cursor: pointer;
}
@media screen and (max-width: 834px) {
  .nav .logo {
    margin: auto;
  }
}
.nav .menu {
  margin-top: auto;
  margin-bottom: auto;
  cursor: pointer;
}
.nav .menu img {
  width: 24px;
}
@media screen and (min-width: 834px) {
  .nav .menu {
    display: none;
  }
}
.nav .items {
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
  margin-left: 2rem;
  margin-right: 2rem;
}
@media screen and (max-width: 834px) {
  .nav .items {
    display: none;
  }
}
@media screen and (min-width: 991px) {
  .nav .items {
    margin-left: 5rem;
    margin-right: 5rem;
  }
}
.nav .items a {
  color: white;
  margin-top: auto;
  margin-bottom: auto;
  cursor: pointer;
}
.nav .items a.active {
  color: #03E287;
}
.nav .items .dropdown-container {
  margin-top: auto;
  margin-bottom: auto;
  cursor: pointer;
  position: relative;
}
.nav .items .dropdown-container .title {
  cursor: pointer;
  display: flex;
}
.nav .items .dropdown-container .title div {
  margin-right: 0.5rem;
}
.nav .items .dropdown-container .title img {
  width: 20px;
  margin-top: auto;
  margin-bottom: auto;
}
.nav .items .dropdown-container .dropdown {
  position: absolute;
  width: 200px;
  top: 30;
  left: 0;
  padding: 1rem;
  background: rgba(1, 20, 29, 0.19);
  backdrop-filter: blur(9.5px);
  border-radius: 17px;
  border: 1px solid #01141D;
}
.nav .items .dropdown-container .dropdown.d-none {
  display: none;
}
.nav .cta-button {
  display: flex;
  border-radius: 20px;
  padding-right: 1rem;
  padding-left: 1rem;
  border: 2px solid #03E287;
  cursor: pointer;
}
@media screen and (max-width: 834px) {
  .nav .cta-button {
    display: none;
  }
}
.nav .cta-button img {
  width: 1rem;
  height: 1rem;
  margin-top: auto;
  margin-bottom: auto;
}
.nav .cta-button span {
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 0.25rem;
  color: #03E287;
}

.text-green {
  color: #03E287;
}

.sideNav {
  font-size: 20px;
  font-weight: 500;
  max-width: 605px;
  height: 100%;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: #002730;
  overflow-x: hidden;
  transition: 0.5s;
  width: 90%;
  padding: 2rem;
}
@media screen and (min-width: 834px) {
  .sideNav {
    width: 0px;
    padding: 0px;
  }
}
.sideNav.d-none {
  width: 0px;
  padding: 0;
}
.sideNav .header {
  margin-bottom: 2rem;
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
}
.sideNav .header img {
  cursor: pointer;
}
.sideNav .items {
  margin-top: 2rem;
}
.sideNav .items div {
  margin-bottom: 2rem;
  cursor: pointer;
}
.sideNav .items div .whitepaper-icon {
  margin-right: 0.5rem;
}
.sideNav .items div span {
  margin-top: auto;
  margin-bottom: auto;
}
.sideNav .items .title {
  display: flex;
  cursor: pointer;
}
.sideNav .items .title div {
  margin-right: 0.5rem;
}
.sideNav .items .title img {
  margin-bottom: auto;
}
.sideNav .items .dropdown {
  margin-left: 2rem;
}
.sideNav .items .dropdown a {
  text-decoration: none;
  color: white;
}
.sideNav .items .dropdown.d-none {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/styles/navbar.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AADF;AAEE;EARF;IASI,kBAAA;IACA,iBAAA;IACA,mBAAA;IACA,kBAAA;EACF;AACF;AAAE;EACE,qBAAA;AAEJ;AAAE;EACE,eAAA;AAEJ;AADI;EAFF;IAGI,YAAA;EAIJ;AACF;AAFE;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;AAIJ;AAHI;EACE,WAAA;AAKN;AAHI;EAPF;IAQI,aAAA;EAMJ;AACF;AAJE;EAIE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;AAGJ;AAVI;EADF;IAEI,aAAA;EAaJ;AACF;AAPI;EATF;IAUI,iBAAA;IACA,kBAAA;EAUJ;AACF;AARI;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAUN;AATM;EACE,cAAA;AAWR;AAPI;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AASN;AARM;EACE,eAAA;EACA,aAAA;AAUR;AATQ;EACE,oBAAA;AAWV;AATQ;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;AAWV;AARM;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,OAAA;EACA,aAAA;EACA,iCAAA;EACA,4BAAA;EACA,mBAAA;EACA,yBAAA;AAUR;AATQ;EACE,aAAA;AAWV;AALE;EAIE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AAIJ;AAZI;EADF;IAEI,aAAA;EAeJ;AACF;AARI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AAUN;AARI;EACE,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;AAUN;;AANA;EACE,cAAA;AASF;;AAPA;EAKE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;AAMF;AAtBE;EADF;IAEI,UAAA;IACA,YAAA;EAyBF;AACF;AAXE;EACE,UAAA;EACA,UAAA;AAaJ;AAVE;EACE,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;AAYJ;AAXI;EACE,eAAA;AAaN;AAVE;EACE,gBAAA;AAYJ;AAXI;EACE,mBAAA;EACA,eAAA;AAaN;AAZM;EACE,oBAAA;AAcR;AAZM;EAEE,gBAAA;EACA,mBAAA;AAaR;AATI;EACE,aAAA;EACA,eAAA;AAWN;AAVM;EACE,oBAAA;AAYR;AAVM;EACE,mBAAA;AAYR;AATI;EACE,iBAAA;AAWN;AAVM;EACE,qBAAA;EACA,YAAA;AAYR;AAVM;EACE,aAAA;AAYR","sourcesContent":["\r\n\r\n.nav{\r\n  margin-top: 50px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  max-width: 74rem;\r\n  margin-left: 0px;\r\n  margin-right: 0px;\r\n  font-size: 16px;\r\n  @media screen and (min-width: 991px){\r\n    margin-right:auto;\r\n    margin-left:auto;\r\n    padding-right: 2rem;\r\n    padding-left: 2rem;\r\n  }\r\n  a{\r\n    text-decoration: none;\r\n  }\r\n  .logo{\r\n    cursor: pointer;\r\n    @media screen and (max-width: 834px){\r\n      margin:auto;\r\n    }\r\n  }\r\n  .menu{\r\n    margin-top: auto;\r\n    margin-bottom: auto;\r\n    cursor: pointer;\r\n    img{\r\n      width: 24px;\r\n    }\r\n    @media screen and (min-width: 834px){\r\n      display: none;\r\n    }\r\n  }\r\n  .items{\r\n    @media screen and (max-width: 834px){\r\n      display: none;\r\n    }\r\n    flex-grow: 1;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-left: 2rem;\r\n    margin-right: 2rem;\r\n    @media screen and (min-width: 991px){\r\n      margin-left: 5rem;\r\n      margin-right: 5rem;\r\n    }\r\n    \r\n    a{\r\n      color: white;\r\n      margin-top: auto;\r\n      margin-bottom: auto;\r\n      cursor: pointer;\r\n      &.active{\r\n        color: #03E287;\r\n      }\r\n    }\r\n    \r\n    .dropdown-container{\r\n      margin-top: auto;\r\n      margin-bottom: auto;\r\n      cursor: pointer;\r\n      position: relative;\r\n      .title{\r\n        cursor: pointer;\r\n        display: flex;\r\n        div{\r\n          margin-right: 0.5rem;\r\n        }\r\n        img{\r\n          width: 20px;\r\n          margin-top: auto;\r\n          margin-bottom: auto;\r\n        }\r\n      }\r\n      .dropdown{\r\n        position: absolute;\r\n        width: 200px;\r\n        top:30;\r\n        left: 0;\r\n        padding: 1rem;\r\n        background: rgba(1, 20, 29, 0.19);\r\n        backdrop-filter: blur(9.5px);\r\n        border-radius: 17px;\r\n        border: 1px solid #01141D;\r\n        &.d-none{\r\n          display: none;\r\n        }\r\n      }\r\n\r\n    }\r\n  }\r\n  .cta-button{\r\n    @media screen and (max-width: 834px){\r\n      display:none;\r\n    }\r\n    display: flex;\r\n    border-radius: 20px;\r\n    padding-right: 1rem;\r\n    padding-left: 1rem;\r\n    border: 2px solid #03E287;\r\n    cursor: pointer;\r\n    img{\r\n      width: 1rem;\r\n      height: 1rem;\r\n      margin-top: auto;\r\n      margin-bottom:auto;\r\n    }\r\n    span{\r\n      margin-top: auto;\r\n      margin-bottom: auto;\r\n      margin-left: 0.25rem;\r\n      color:#03E287;\r\n    }\r\n  }\r\n}\r\n.text-green{\r\n  color:#03E287;\r\n}\r\n.sideNav{\r\n  @media screen and (min-width: 834px){\r\n    width: 0px;\r\n    padding: 0px;\r\n  }\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n  max-width: 605px;\r\n  height: 100%;\r\n  position: fixed;\r\n  z-index: 1;\r\n  top: 0;\r\n  left: 0;\r\n  background-color: #002730;\r\n  overflow-x: hidden;\r\n  transition: 0.5s;\r\n  width:90%;\r\n  padding:2rem;\r\n  &.d-none{\r\n    width: 0px;\r\n    padding:0;\r\n  }\r\n  \r\n  .header{\r\n    margin-bottom: 2rem;\r\n    margin-top: 1rem;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    img{\r\n      cursor:pointer;\r\n    }\r\n  }\r\n  .items{\r\n    margin-top: 2rem;\r\n    div{\r\n      margin-bottom: 2rem;\r\n      cursor: pointer;\r\n      .whitepaper-icon{\r\n        margin-right: 0.5rem;\r\n      }\r\n      span{\r\n\r\n        margin-top: auto;\r\n        margin-bottom: auto;\r\n      }\r\n    }\r\n    // dropdown-container\r\n    .title{\r\n      display: flex;\r\n      cursor: pointer;\r\n      div{\r\n        margin-right: 0.5rem;\r\n      }\r\n      img{\r\n        margin-bottom: auto;\r\n      }\r\n    }\r\n    .dropdown{\r\n      margin-left: 2rem;\r\n      a{\r\n        text-decoration: none;\r\n        color: white;\r\n      }\r\n      &.d-none{\r\n        display: none;\r\n      }\r\n    }\r\n    \r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
